<app-home-welcome></app-home-welcome>

<app-home-account-codes></app-home-account-codes>

<app-home-our-services></app-home-our-services>

<app-home-banner></app-home-banner>

<app-home-formations></app-home-formations>

<app-home-events></app-home-events>

<app-home-faq></app-home-faq>
